<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({
  catalog: { type: Object, default: () => ({}) },
  value: { type: Object, required: true },
});

const emit = defineEmits(['update:value']);
const { t } = useI18n();
const update = (field, fieldValue) =>
  emit('update:value', { ...props.value, [field]: fieldValue });
</script>

<template>
  <div class="grid gap-4">
    <section class="grid gap-3">
      <h2 class="text-lg font-semibold text-lais-text">
        {{ t('POST_SALE.TOPICS.OTHER.TITLE') }}
      </h2>
      <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
        {{ t('POST_SALE.TOPICS.OTHER.SUBJECT') }}
        <select
          :value="value.subject"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-2 font-normal"
          @change="update('subject', $event.target.value)"
        >
          <option value="">
            {{ t('POST_SALE.TOPICS.OTHER.SUBJECT_PLACEHOLDER') }}
          </option>
          <option
            v-for="option in catalog.other_subjects || []"
            :key="option.id"
            :value="option.id"
          >
            {{ option.label }}
          </option>
        </select>
      </label>
    </section>
    <section class="grid gap-3">
      <h2 class="text-lg font-semibold text-lais-text">
        {{ t('POST_SALE.TOPICS.OTHER.OBSERVATION_TITLE') }}
      </h2>
      <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
        {{ t('POST_SALE.TOPICS.OTHER.OBSERVATION') }}
        <textarea
          :value="value.observation"
          rows="3"
          class="rounded-lais border border-lais-border bg-white p-2 font-normal"
          :placeholder="t('POST_SALE.TOPICS.OTHER.PLACEHOLDER')"
          @input="update('observation', $event.target.value)"
        />
      </label>
    </section>
  </div>
</template>
